import { List, X } from 'react-bootstrap-icons';
import { useState } from 'react';
import { Link } from 'react-scroll';
import { menuItems } from '../../config';

// Navbar 
const Navbar = () => {

    const [menu, setMenu] = useState(false);

    const toggleMenu = () => {
        menu ? setMenu(false) : setMenu(true);
    }

    return (
        <div>
            <div className='px-6 py-3 flex justify-between'>
                <div>
                    <img
                        src="assets/profile/logo.png"
                        alt='my-logo'
                        width='40px'
                        className='rounded-md'
                    />
                </div>
                <div className='flex'>

                    {menu ? (
                        <div className='text-3xl md:hidden' onClick={toggleMenu}>
                            <X />
                        </div>
                    ) :
                        (
                            <div className='text-3xl md:hidden' onClick={toggleMenu}>
                                <List />
                            </div>
                        )}

                    <div className='md:flex md:block space-x-4 cursor-pointer hidden font-semibold'>
                        {menuItems.map((item, index) => {
                            return (<Link to={item.path} smooth duration={800} key={index} >{item.name}</Link>)
                        })}
                    </div>
                </div>

            </div>
            {menu && (<div className='space-y-4 text-center md:hidden font-semibold'>
                {menuItems.map((item, index) => {
                    return (
                        <div key={index}>
                            <Link to={item.path} smooth duration={800}>{item.name}</Link>
                        </div>
                    )
                })}
            </div>)}
        </div>
    );
}

export default Navbar;